import { css } from "@emotion/react";
import { ICONS, Icon } from "src/modules/ui-elements/Icon";
import ToggleSwitch from "../ToggleSwitch";
import React from "react";
import {ResizedImage} from "../resizedImage";
import { Loader } from "@/modules/editor-v2/MiddleSection/EditorTopToolBar";
export const ButtonTypes = {
  light:'light',
  primary:'primary',
  violate: "violate",
  violateBGWhite: "violate-bg-white",
  blackBGgrey:"black-bg-grey",
};

interface SecondaryButtonProps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  type?: 'violateBGWhite' | 'anotherType' | 'black-bg-grey'; 
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  subtitleIcon?: React.ReactNode;
  style?: React.CSSProperties | {};
  isNew?: boolean;
  groupedPreset?: any;
  leftTextIcon?: React.ReactNode;
  iconColor?: string;
  transperencyIcon?: boolean;
  toggleSwitch?: boolean;
  toggleType?: string; 
  loading?: boolean;
  disabled?: boolean;
  leftIconType?: 'icon' | 'image' | 'element'; 
  rightIconType?: 'icon' | 'image';
  specialText?: string;
  dropdownStyle?: React.CSSProperties;
  onToggle?: () => void;
  onClick?: () => void;
  dropDownStatus?: boolean;
  closeDropDown?: () => void;
  openDropDown?: () => void;
  leftIconSize?: number;
  rightIconSize?: number;
  multiSelect?: boolean;
  onMultiSelectClick?: () => void;
  rightIconStyle?: React.CSSProperties;
  leftIconStyle?: React.CSSProperties;
}

const SecondaryButton:React.FC<SecondaryButtonProps> = ({
  children,
  title,
  subtitle,
  type='violateBGWhite',
  leftIcon,
  rightIcon,
  subtitleIcon,
  style,
  isNew,
  groupedPreset,
  leftTextIcon,
  iconColor,
  transperencyIcon,
  toggleSwitch,
  toggleType,
  loading=false,
  disabled,
  leftIconType="icon",
  specialText='NEW',
  dropdownStyle={},
  onToggle = () => {},
  onClick = () => {},
  dropDownStatus = false,
  closeDropDown = () => {},
  openDropDown = () => {},
  leftIconSize = 16,
  rightIconSize = 16,
  multiSelect=false,
  onMultiSelectClick = () => {},
  rightIconStyle,
  leftIconStyle,
}) => {
  const typeBasedStyles = getCorrespondingStyleObject(type,disabled);
  const disabledHandler = () => {};
  return (
    <div css={(children && dropDownStatus) && typeBasedStyles.container} >
    <div
      css={(children && dropDownStatus) ? typeBasedStyles.dropdownStyle : typeBasedStyles.container}
      style={{ ...styles.container, ...style }}
      disabled={disabled}
      onClick={disabled ? disabledHandler : onClick}
    > 
      
      {groupedPreset && (
        <div css={typeBasedStyles.groupedPreset}>
          <ResizedImage src={groupedPreset} />
        </div>
      )}
      {leftIcon && leftIconType === "icon" && (
        <div css={typeBasedStyles.iconContainer} style={{...styles.iconContainer, ...leftIconStyle}}>
          <Icon src={leftIcon} height={leftIconSize} width={leftIconSize} />
        </div>
      )}
      {
        leftIconType === "colorContainer" && (
          <div css={typeBasedStyles.iconContainer} style={{...styles.iconContainer, ...leftIconStyle}}>
            <Icon src={leftIcon} height={leftIconSize} width={leftIconSize} />
          </div>
        )
      }
      {leftIcon && leftIconType === "element" && (
        <div css={typeBasedStyles.iconContainer} style={{...styles.iconContainer, ...leftIconStyle}}>
          {(leftIcon)}
        </div>
      )}
      
      {iconColor && (
      <div css={typeBasedStyles.iconContainer} style={styles.iconContainer}>
        <div style={{background: iconColor, height:"32px", width:"32px", borderRadius: "2px"}}></div>
        </div>)}
        {transperencyIcon && (
      <div css={typeBasedStyles.iconContainer} style={styles.iconContainer}>
        <Icon src={ICONS.transperency} height="32" width="32" />
        </div>)}
      {leftTextIcon && (
      <div css={typeBasedStyles.iconContainer} style={styles.iconContainer}>
        <Icon src={leftTextIcon} height={leftIconSize} width={leftIconSize} />
        </div>)}
      <div style={styles.textContainer}>
        <div
          css={typeBasedStyles.textLeftContainer}
          style={styles.textLeftContainer}
        >
          {title && (
            <div css={typeBasedStyles.textTitleContainer}>
              {title}
              {isNew && <div css={css`display:flex;position:relative;`}><span css={styles.new }>{specialText}</span></div>}
            </div>
          )}
          {subtitle && (
            <div css={typeBasedStyles.textSubtitleContainer}>
              {subtitle}
              {subtitleIcon && <Icon src={subtitleIcon} height="8" width="8" />}
            </div>
          )}
        </div>
        {toggleSwitch && (
          <div style={styles.textRightContainer}>
            <ToggleSwitch isChecked={dropDownStatus} setIsChecked={()=>{
              dropDownStatus ? closeDropDown() : openDropDown()
            }} type={toggleType} onClick={onToggle} disabled={disabled} />
          </div>
        )}
      </div>
      {rightIcon &&  (
        (type == "black-bg-grey") ? 
         <div css={typeBasedStyles.iconContainer} style={rightIconStyle ? rightIconStyle : {...styles.iconContainer, background: groupedPreset?"none": "EEEEEE"}} onClick={dropDownStatus ? closeDropDown : openDropDown}>
            {loading ? <Loader type='voilet' /> : <Icon src={rightIcon} height={rightIconSize} width={rightIconSize} style={{transform:dropDownStatus ? 'rotate(180deg)' :'rotate(0deg)'  }} />}
        </div>
        : 
        multiSelect ?
          <div css={typeBasedStyles.iconContainer} style={{ display: "flex",justifyContent: "center"}} onClick={onMultiSelectClick}>
            {loading ? <Loader type='voilet' /> : <Icon src={rightIcon} height={rightIconSize} width={rightIconSize} style={{transform:dropDownStatus ? 'rotate(180deg)' :'rotate(0deg)'  }} />}
          </div>
        :
        <div css={typeBasedStyles.iconContainer} style={styles.iconContainer} onClick={dropDownStatus ? closeDropDown : openDropDown}>
          {loading ? <Loader type='voilet' /> : <Icon src={rightIcon} height={rightIconSize} width={rightIconSize} style={{transform:dropDownStatus ? 'rotate(180deg)' :'rotate(0deg)'  }} />}
        </div>
      )}
    </div>
    {(children && dropDownStatus) && 
    <div css={styles.dropdownStyle} style={dropdownStyle}>
      {children}
    </div>}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: "3px",
  },
  dropdownStyle:css`
    padding:10px;
  `,
  iconContainer: {
    display: "flex",
    justifyContent: "center",
  },                                                         
  textContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
  },
  textLeftContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    alignItems: "flex-start",
  },
  textRightContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  new: css`
    position:absolute;
    top:0;
    left:0;
    padding: 4px 3px 2px;
    background:linear-gradient(149deg, rgba(95,46,229,1) 14%, rgba(159,53,240,1) 76%);
    color: #fff;
    font-size: 0.5rem;
    border-radius: 2px;
    line-height: 1;
    margin-left: 5px;
    text-align:center;
    `,
};

function getCorrespondingStyleObject(type,disabled) {
  let container,
    dropdownStyle,
    textLeftContainer,
    iconContainer,
    textTitleContainer,
    textSubtitleContainer,
    groupedPreset;
  switch (type) {
    case ButtonTypes.light:{
      container =css`
        width: 100%;
        min-height: 50px;
        border-radius: 4px;
        background-color: #fff;
        opacity:${disabled ? 0.5 : 1};
        font-family: 'Objectivity';
        font-style: normal;
        cursor:${disabled ? 'not-allowed' : 'pointer'};
      `;
      dropdownStyle=css`
       border-bottom: 0.5px solid rgba(0, 0, 0, 0.40);
       border-bottom-left-radius: 0px !important;
       border-bottom-right-radius: 0px !important;
       height:50px;
      `;
      iconContainer = css`
        width: 40px;
        padding: 2px
      `;
      textLeftContainer = css`
        flex: 1;
        color: #262626;
      `;
      textTitleContainer = css`
        display:flex;
        font-weight: 700;
        font-size: 12px;
        line-height: 24px;
        color: #262626;
      `;
      textSubtitleContainer = css`
        font-size: 10px;
        height: 16px;
        display: flex;
        gap: 4px;
        background: linear-gradient(171deg, #262626 0%, #ccc 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      `;

      break;
    }
    case ButtonTypes.primary:{
      container =css`
        width: 100%;
        min-height: 50px;
        border: 1px solid #EEEEEE;
        border-radius: 4px;
        background-color: #fff;
        opacity:${disabled ? 0.5 : 1};
        font-family: 'Objectivity';
        font-style: normal;
        cursor:${disabled ? 'not-allowed' : 'pointer'};
        :hover{
          border: 1px solid #DEDEDE;
        };
      `;
      dropdownStyle=css`
       border-bottom: 0.5px solid rgba(0, 0, 0, 0.40);
       border-bottom-left-radius: 0px !important;
       border-bottom-right-radius: 0px !important;
       height:50px;
      `;
      iconContainer = css`
        width: 40px;
      `;
      textLeftContainer = css`
        flex: 1;
        color: #262626;
      `;
      textTitleContainer = css`
        display:flex;
        font-weight: 700;
        font-size: 12px;
        line-height: 24px;
        color: #262626;
      `;
      textSubtitleContainer = css`
        font-size: 10px;
        height: 16px;
        display: flex;
        gap: 4px;
        background: linear-gradient(171deg, #262626 0%, #ccc 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      `;
      groupedPreset = css`
        display: flex;
        justify-content: center;
      `;
      break;
    }
    case ButtonTypes.violate: {
      container =css`
        width: 100%;
        min-height: 50px;
        border: 1px solid #5f2ee5;
        border-radius: 4px;
        background-color: #f3effd;
        opacity:${disabled ? 0.5 : 1};
        font-family: 'Objectivity';
        font-style: normal;
        cursor:${disabled ? 'not-allowed' : 'pointer'};
      `;
      dropdownStyle=css`
       border-bottom: 0.5px solid rgba(95, 46, 229, 0.40);
       border-bottom-left-radius: 0px !important;
       border-bottom-right-radius: 0px !important;
       height:50px;
      `;
      iconContainer = css`
        width: 40px;
      `;
      textLeftContainer = css`
        flex: 1;
        color: #5f2ee5;
      `;
      textTitleContainer = css`
        display:flex;
        font-weight: 700;
        font-size: 12px;
        line-height: 24px;
        color: #5f2ee5;
      `;
      textSubtitleContainer = css`
        font-size: 10px;
        height: 16px;
        display: flex;
        gap: 4px;
        background: linear-gradient(171deg, #9f35f0 0%, #5f2ee5 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      `;

      break;
    }
    case ButtonTypes.violateBGWhite: {
      container = css`
        width: 100%;
        min-height: 50px;
        border: 1px solid #5f2ee5;
        border-radius: 4px;
        background-color: #fff;
        opacity:${disabled ? 0.5 : 1};
        font-family: 'Objectivity';
        font-style: normal;
        cursor:${disabled ? 'not-allowed' : 'pointer'};
      `;
      dropdownStyle=css`
       border-bottom: 0.5px solid rgba(95, 46, 229, 0.40);
       border-bottom-left-radius: 0px !important;
       border-bottom-right-radius: 0px !important;
       height:50px;
      `;
      iconContainer = css`
        width: 40px;
      `;
      textLeftContainer = css`
        flex: 1;
        color: #5f2ee5;
      `;
      textTitleContainer = css`
        display:flex;
        font-size: 12px;
        line-height: 28px;
        color: #5f2ee5;
      `;
      break;
    }
    case ButtonTypes.blackBGgrey:{
      container =css`
        min-height: 40px;
        border-radius: 4px;
        background-color: #F9F9F9;
        font-family: 'Objectivity';
        font-style: normal;
        cursor:${disabled ? 'not-allowed' : 'pointer'};
      `;
      dropdownStyle=css`
       border-bottom: 1px solid #EEEEEE,
       border-bottom-left-radius: 0px !important;
       border-bottom-right-radius: 0px !important;
       borderBottom: 1px solid #EEEEEE, 
       height:50px;
       transition: height 3s bounce;
       
      `;
      iconContainer = css`
        width: 32px;
        height: 32px;
        background-color: #FFF;
        border-radius: 4px;
        margin: 4px
      `;
      textLeftContainer = css`
        flex: 1;
        color: #262626;
      `;
      textTitleContainer = css`
        display:flex;
        font-weight: 700;
        font-size: 12px;
        line-height: 24px;
        color: #262626;
        
      `;
      textSubtitleContainer = css`
        font-size: 10px;
        height: 16px;
        display: flex;
        gap: 4px;
        background: linear-gradient(171deg, #262626 0%, #ccc 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      `;

      break;
    }
  }
  return {
    container,
    dropdownStyle,
    textLeftContainer,
    iconContainer,
    textTitleContainer,
    textSubtitleContainer,
    groupedPreset
  };
}

export default SecondaryButton;
